import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 19C5.16667 19 4.45833 18.7083 3.875 18.125C3.29167 17.5417 3 16.8333 3 16H1V7C1 6.45 1.19583 5.97917 1.5875 5.5875C1.97917 5.19583 2.45 5 3 5H17L23 11V16H21C21 16.8333 20.7083 17.5417 20.125 18.125C19.5417 18.7083 18.8333 19 18 19C17.1667 19 16.4583 18.7083 15.875 18.125C15.2917 17.5417 15 16.8333 15 16H9C9 16.8333 8.70833 17.5417 8.125 18.125C7.54167 18.7083 6.83333 19 6 19ZM15 10H19L16 7H15V10ZM9 10H13V7H9V10ZM3 10H7V7H3V10ZM6 17.25C6.35 17.25 6.64583 17.1292 6.8875 16.8875C7.12917 16.6458 7.25 16.35 7.25 16C7.25 15.65 7.12917 15.3542 6.8875 15.1125C6.64583 14.8708 6.35 14.75 6 14.75C5.65 14.75 5.35417 14.8708 5.1125 15.1125C4.87083 15.3542 4.75 15.65 4.75 16C4.75 16.35 4.87083 16.6458 5.1125 16.8875C5.35417 17.1292 5.65 17.25 6 17.25ZM18 17.25C18.35 17.25 18.6458 17.1292 18.8875 16.8875C19.1292 16.6458 19.25 16.35 19.25 16C19.25 15.65 19.1292 15.3542 18.8875 15.1125C18.6458 14.8708 18.35 14.75 18 14.75C17.65 14.75 17.3542 14.8708 17.1125 15.1125C16.8708 15.3542 16.75 15.65 16.75 16C16.75 16.35 16.8708 16.6458 17.1125 16.8875C17.3542 17.1292 17.65 17.25 18 17.25Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgVan);
export default ForwardRef;
